import { ReactNode, useState } from 'react'

import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { useRegisterQueryClient } from './invalidateLoanQueries'

const QueryProvider = ({ children }: { children: ReactNode }) => {
  // eslint-disable-next-line react-naming-convention/use-state -- the client lives as long as the provider and is never replaced
  const [queryClient] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: (error, query) => {
            if (query.meta?.operation) {
              ;(error as any).operation = query.meta?.operation
            }
          },
        }),
      }),
  )
  useRegisterQueryClient(queryClient)

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}

export default QueryProvider
